import type { SxProps, Theme } from '@mui/material';
import { type SystemStyleObject } from '@mui/system/styleFunctionSx';

type SxElement = boolean | SystemStyleObject<Theme> | ((theme: Theme) => SystemStyleObject<Theme>);

export const mergeSx = (...sxProps: (SxProps<Theme> | undefined)[]) => sxProps.flatMap<SxElement>((sx) => sx ?? []);
